import React from 'react';
import { Sparkles } from 'lucide-react';

// Grouped by the shape of the question rather than by tool, since
// that's how operators think — and because the groups double as the
// documentation for what the assistant can now reach.
const EXAMPLES = [
  {
    group: 'Ask',
    items: [
      'What RTD coffee brands are we tracking in California?',
      'Show me Olipop\'s recent Instagram metrics.',
      'Which kombucha brands use ginger?',
    ],
  },
  {
    group: 'Rank',
    items: [
      'Which brands have the biggest Instagram following?',
      'Top 10 by consumer sentiment in kombucha.',
      'Which brands are breaking out this week?',
    ],
  },
  {
    group: 'Analyse',
    items: [
      'Break down our portfolio by category.',
      'Average momentum by country.',
      'What\'s working for Poppi on TikTok right now?',
    ],
  },
  {
    group: 'Keep up',
    items: [
      'What\'s changed at Olipop since last month?',
      'Which brands haven\'t been researched in 90 days?',
      'What\'s in my review queue?',
    ],
  },
  {
    group: 'Report',
    items: [
      'Generate a report on RTD coffee brands in California with a bar chart by category.',
      'Build a summary report of all brands founded after 2022, with charts by country and marketplace.',
      'Report on the brands with the highest momentum this week, with a chart of average momentum by category.',
    ],
  },
];

function EmptyState({ onPick }) {
  return (
    <div className="chat-empty">
      <div className="chat-empty-hero">
        <span className="chat-empty-icon">
          <Sparkles size={24} strokeWidth={2.75} />
        </span>
        <h2>Ask anything about your brand database.</h2>
        <p>
          The assistant reads your brands, products, social metrics,
          sentiment, tags, contacts, change history and review queue
          directly. Every answer is grounded in real rows — click the
          <code>tool calls</code> disclosure under any reply to see exactly
          what was queried.
        </p>
      </div>

      <div className="chat-empty-groups">
        {EXAMPLES.map(group => (
          <div key={group.group} className="chat-empty-group">
            <span className="card-kicker">{group.group}</span>
            <div className="chat-empty-items">
              {group.items.map(text => (
                <button
                  key={text}
                  type="button"
                  className="chat-empty-item"
                  onClick={() => onPick(text)}
                >
                  {text}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmptyState;
